import React from 'react';
import * as R from 'ramda';
// components
import { PopperComponent } from '../popper';
// helpers/constants
import * as G from '../../helpers';
// icons
import * as I from '../../svgs';
// ui
import { Box, Flex } from '../../ui';
//////////////////////////////////////////////////

const Error = ({ color, error }) => (
  <Box p='5px' color={R.or(color, 'light.mainRed')}>
    {error}
  </Box>
);

const Errors = ({
  errors,
  alignItems,
  errorColor,
  flexDirection,
  wrapperMaxWidth,
  withoutNumbering,
  wrapperPadding = 10,
}) => (
  <Flex
    p={wrapperPadding}
    alignItems={alignItems}
    maxWidth={wrapperMaxWidth}
    flexDirection={flexDirection}
  >
    {
      errors.map((error, index) => (
        <Error key={index} color={errorColor} error={`${withoutNumbering ? '' : `${R.inc(index)}. `}${error}`} />
      ))
    }
  </Flex>
);

const ErrorsPopover = ({ errors, options, iconMargin, wrapperPadding }) => {
  if (G.isNilOrEmpty(errors)) return null;

  const {
    iconColor,
    alignItems,
    errorColor,
    iconBgColor,
    borderColor,
    flexDirection,
    wrapperMaxWidth,
    withoutNumbering,
    position = 'right',
  } = R.or(options, {});

  return (
    <PopperComponent
      type='hover'
      usePortal={true}
      position={position}
      borderColor={R.or(borderColor, G.getTheme('listActions.borderColor'))}
      content={(
        <Errors
          errors={errors}
          errorColor={errorColor}
          alignItems={alignItems}
          flexDirection={flexDirection}
          wrapperPadding={wrapperPadding}
          wrapperMaxWidth={wrapperMaxWidth}
          withoutNumbering={withoutNumbering}
        />
      )}
    >
      <Box m={R.or(iconMargin, '0 10px')}>{I.warningIcon(iconColor, 20, 20, iconBgColor)}</Box>
    </PopperComponent>
  );
};

export default ErrorsPopover;
